import moment from "moment";
import React from "react";
import { TCRBRecord } from "../../../../../redux/app/crb/@types";
import { TCRBK0 } from "../../../../../redux/app/crb/groups/crb-k";
import { commonUtils } from "../../../../../redux/_common";
import CRBTableRows from "../CRBTableRows";

type OwnProps = {
	crbRecord: TCRBRecord;
	isStrikedOff?: boolean;
};
type CRBK0PreviewProps = OwnProps;
function CRBK0Preview(props: CRBK0PreviewProps) {
	const crbRecord = props.crbRecord as TCRBK0;
	const operationDate = moment(crbRecord.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	function renderMain() {
		return (
			<CRBTableRows
				record={crbRecord}
				tableRows={[
					[operationDate, "K", "_", renderItemRemarks()],
					[null, null, "NOTE", crbRecord.remarks],
				]}
			/>
		);
	}

	function renderItemRemarks() {
		return (
			<h4 className="font-medium uppercase">
				{crbRecord.itemO1.generalRemarks}
			</h4>
		);
	}

	return renderMain();
}

export default CRBK0Preview;
